import { theme } from 'theme/App.theme';
import makeStyles from '@mui/styles/makeStyles';
export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexFlow: 'row wrap',
    flexGrow: 1,
    margin: '0 auto',
    padding: '1.25rem',
    [theme.breakpoints.up('viewportMobileMid')]: {
      padding: 0,
      maxWidth: '70%',
      margin: '1.25rem auto',
    },
    [theme.breakpoints.up('viewportMedium')]: {
      maxWidth: 'unset',
      padding: '1.25rem',
      margin: '0',
    },
    [theme.breakpoints.up('viewportLarge')]: {
      width: '95%',
      maxWidth: '78.125rem',
      padding: '2.8125rem 1.25rem',
      margin: '0 auto',
    },
    [theme.breakpoints.up('viewportXLarge')]: {
      width: '90%',
    },
  },
  dealerInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '3.75rem',
  },
  header: {
    width: 'calc(100vw - 2.5rem)',
    marginBottom: '3.125rem',
    [theme.breakpoints.up('lg')]: {
      width: '40%',
      marginBottom: '3.4375rem',
    },
  },
  headerTitle: {
    width: '21.25rem',
    height: '2rem',
    marginBottom: '0.3125rem',
    [theme.breakpoints.up('md')]: {
      height: '2.25rem',
    },
    [theme.breakpoints.up('lg')]: {
      height: '2.75rem',
    },
    [theme.breakpoints.up('xl')]: {
      height: '3rem',
    },
  },
  headerDescription: {
    width: '100%',
    height: '1rem',
    marginBottom: '0.625rem',
  },
  vehicleInformationContainer: {},
  stepContainer: {
    width: '100%',
    padding: '0 1.25rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      width: '50%',
      padding: '0 0.5rem',
    },
    [theme.breakpoints.up('lg')]: {
      width: '42%',
      minWidth: '28.4375rem',
    },
  },
  step1Container: {
    display: 'flex',
    flexFlow: 'row wrap',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexDirection: 'row',
      paddingLeft: '2.625rem',
      paddingRight: '1rem',
      justifyContent: 'space-between',
      flexWrap: 'nowrap',
    },
  },
  step: {
    width: '100%',
    height: '1.75rem',
    marginBottom: '0.9375rem',
    [theme.breakpoints.up('md')]: {
      marginBottom: '2.1875rem',
    },
    [theme.breakpoints.up('viewportLarge')]: {
      height: '2.5rem',
    },
    '&.partial': {
      [theme.breakpoints.up('md')]: {
        maxWidth: '26.875rem',
        width: '46.1%',
      },
    },
  },
  zipInput: {
    width: '100%',
    height: '2.25rem',
    marginBottom: '2.25rem',
  },
  filter: {
    width: '100%',
    height: '2.875rem',
    marginBottom: '0.9375rem',
    [theme.breakpoints.up('md')]: {
      marginBottom: '1.25rem',
    },
    [theme.breakpoints.up('viewportLarge')]: {
      height: '2.5rem',
    },
  },
  dealerTabs: {
    width: '20rem',
    marginBottom: '0.9375rem',
    [theme.breakpoints.up('viewportMobileMid')]: {
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  dealerTab: {
    width: '50%',
    height: '3.5625rem',
    boxShadow:
      '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
  },
  dealerTabActive: {
    boxShadow: '0 0.1875rem 0.625rem 0.0625rem rgb(0 0 0 / 21%)',
  },
  changeDealerButton: {
    height: '2.875rem',
    width: '100%',
  },
  dealerCard: {
    height: '13.4375rem',
    marginBottom: '0.9375rem',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      height: '14.75rem',
    },
  },
  dealersMap: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      display: 'block',
      height: '100%',
      width: 'calc(100% - 1.375rem)',
      marginLeft: '1.375rem',
      flexGrow: 1,
      flexBasis: 0,
    },
    [theme.breakpoints.up('xl')]: {
      width: 'calc(100% - 2rem)',
      marginLeft: '2rem',
    },
  },
  dropdownTitle: {
    height: '1.5rem',
    width: '3.125rem',
  },
  taxonomyTab: {
    width: '80%',
    margin: '1.25rem 0',
    maxWidth: '23.75rem',
  },
  dropdown: {
    height: '3rem',
    marginBottom: '1.875rem',
    width: '100%',
    maxWidth: '18.75rem',
  },
  dropdownContainer: {
    [theme.breakpoints.up('md')]: {
      marginTop: '1.25rem',
    },
  },
  vehicleCard: {
    width: '100%',
    marginTop: '1.25rem',
    marginBottom: '3.875rem',
    '&.basic, &.offers': {
      height: '13.875rem',
      [theme.breakpoints.up('viewportMobileMid')]: {
        height: '15.1875rem',
      },
      [theme.breakpoints.up('md')]: {
        marginTop: '0',
        height: '14.5rem',
      },
      [theme.breakpoints.up('viewportLarge')]: {
        height: '17.875rem',
      },
      [theme.breakpoints.up('viewportXLarge')]: {
        height: '21.5rem',
      },
    },
    '&.bap, &.inventory': {
      maxWidth: '28.4375rem',
      height: '28.125rem',
      [theme.breakpoints.up('viewportMobileMid')]: {
        height: '27.8125rem',
      },
      [theme.breakpoints.up('md')]: {
        marginTop: '0',
        height: '28.75rem',
      },
      [theme.breakpoints.up('viewportLarge')]: {
        height: '30.625rem',
      },
      [theme.breakpoints.up('viewportXLarge')]: {
        height: '31.25rem',
      },
    },
  },
  vehicleDataContainer: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: '1.625rem',
    },
  },
  formLabel: {
    width: '15%',
    height: '1.25rem',
  },
  formInput: {
    height: '2.5rem',
    marginBottom: '1.875rem',
    width: '100%',
  },
  formContainer: {
    [theme.breakpoints.up('md')]: {
      marginTop: '1.25rem',
    },
  },
  inputContainer: {
    paddingLeft: '1.25rem',
  },
  disclaimerTextContainer: {
    marginBottom: '3.25rem',
    [theme.breakpoints.up('md')]: {
      paddingLeft: '1.25rem',
    },
  },
  disclaimerText: {
    height: '1.25rem',
    width: '100%',
  },
  submitButton: {
    height: '3.125rem',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      marginLeft: '1.25rem',
      width: '12.5rem',
    },
  },
  container: {
    display: 'flex',
    flexFlow: 'row wrap',
    boxSizing: 'border-box',
    width: '100%',
  },
});
